import type { MediaLightboxItemReference, ShowMediaLightbox } from '../MediaLightboxStore.types';
import { useMediaLightboxStore } from '../useMediaLightboxStore';

type UseMediaLightboxCurrentItemReference = () => MediaLightboxItemReference | undefined;
export const useMediaLightboxCurrentItemReference: UseMediaLightboxCurrentItemReference = () =>
  useMediaLightboxStore((state) => state.instance?.currentItem);

type UseMediaLightboxMessageId = () => string | undefined;
export const useMediaLightboxMessageId: UseMediaLightboxMessageId = () =>
  useMediaLightboxStore((state) => state.instance?.messageId);

type UseIsMediaLightboxSharedMessage = () => boolean;
export const useIsMediaLightboxSharedMessage: UseIsMediaLightboxSharedMessage = () =>
  useMediaLightboxStore((state) => state.instance?.isSharedMessage === true);

type UseIsMediaLightboxOpen = () => boolean;
export const useIsMediaLightboxOpen: UseIsMediaLightboxOpen = () =>
  useMediaLightboxStore((state) => state.instance != null);

type UseHideLightboxCallback = () => () => void;
export const useHideLightboxCallback: UseHideLightboxCallback = () => useMediaLightboxStore((state) => state.hide);

type UseShowLightboxCallback = () => ShowMediaLightbox;
export const useShowLightboxCallback: UseShowLightboxCallback = () => useMediaLightboxStore((state) => state.show);
